//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import autocomplete from '~/mixins/components/autocomplete';

const isValidCountry = (string) => {
  return /^[A-Za-z]{2}$/.test(string);
};

export default {
  name: 'autocomplete-airport',
  mixins: [autocomplete],
  props: {
    point: {
      type: String,
      default: '',
    },
    departure: {
      type: String,
      default: '',
    },
    country: {
      type: String,
      default: '',
    },
    contractId: {
      type: Number,
      default: null,
    },
    showCode: {
      type: Boolean,
      default: true,
    },
    any: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    company: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      updateKey: 1,
      searchKeys: [
        {
          name: 'cityName',
          weight: 0.1,
        },
        {
          name: 'cityEn',
          weight: 0.1,
        },
        {
          name: 'countryName',
          weight: 0.1,
        },
        {
          name: 'country',
          weight: 0.1,
        },
        {
          name: 'name',
          weight: 1,
        },
        {
          name: 'nameEn',
          weight: 1,
        },
        {
          name: 'code',
          weight: 1,
        },
        {
          name: 'codeEn',
          weight: 3,
        },
      ],
    };
  },
  computed: {
    params () {
      return {
        ...(this.point && { point: this.point }),
        ...(this.departure && { departure: this.departure }),
        ...(this.country && { country: this.country }),
        ...(this.company && this.company !== 'all' && { company: this.company }),
        ...(this.contractId && { contractId: this.contractId }),
        ...(this.any && { anyAirport: this.any }),
      };
    },
    isPointAll () {
      return !!this.point && this.point === 'all';
    },
  },
  watch: {
    departure: {
      handler () {
        this.updateKey += 1;
      },
    },
    country: {
      handler () {
        this.updateKey += 1;
      },
    },
    contractId: {
      handler () {
        this.updateKey += 1;
      },
    },
    company: {
      handler () {
        this.updateKey += 1;
      },
    },
  },
  methods: {
    mapFunction (item) {
      const countryTranslator = new Intl.DisplayNames(
        [this.$locale],
        {
          type: 'region',
          fallback: 'code',
        }
      );
      const countryName = item.country && isValidCountry(item.country)
        ? countryTranslator.of(item.country)
        : '';
      return {
        ...item,
        countryName,
      };
    },
  },
};
